import { Flex, Typography, Page } from 'components';
import { ReactElement } from 'react';

const MfaSupport = (): ReactElement => {
  return (
    <>
      <Page title="Suporte">
        <Flex flex={1} backgroundColor="gray_100" alignItems="center" justifyContent="center" flexDirection="column" maxHeight={500} padding={50}>
          <Flex alignSelf="center" flexDirection="column" padding={24} justifyContent="center" height={500} width={600} backgroundColor="white">
            <Flex justifyContent="center">
              <Flex marginBottom={16}>
                <Typography fontWeight="bold" color="dark_350">
                  Entre em contato conosco
                </Typography>
              </Flex>
              <Flex width={530} justifyContent="center">
                <Flex marginBottom={32} justifyContent="center">
                  <Typography type="type1" color="dark_350" textAlign="center">
                    Estamos aqui para ajudar! Se precisar de assistência, por favor, não hesite em entrar em contato conosco.
                  </Typography>
                </Flex>
              </Flex>
            </Flex>
            <Flex flexDirection="row" marginBottom={32} justifyContent="space-between">
              <Flex flexDirection="column" padding="10px">
                <Typography fontWeight="bold" color="primary_400">
                  Horário de atendimento
                </Typography>
                <Flex marginTop="8px">
                  <Typography type="type1" color="dark_350">
                    8h às 18h - Segunda a Sexta
                  </Typography>
                </Flex>
              </Flex>
              <Flex flexDirection="column" padding="10px">
                <Typography fontWeight="bold" color="primary_400">
                  WhatsApp
                </Typography>
                <Flex marginTop="8px">
                  <Typography type="type1" color="dark_350">
                    (48) 9 9106-7463
                  </Typography>
                </Flex>
              </Flex>
              <Flex flexDirection="column" padding="10px">
                <Typography fontWeight="bold" color="primary_400">
                  E-mail
                </Typography>
                <Flex marginTop="8px">
                  <Typography type="type1" color="dark_350">
                    contato@melver.com.br
                  </Typography>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Page>
    </>
  );
};

export default MfaSupport;
